import * as actions from "./actionTypes";

const initialData = {
  loaderPesoCompetencia: false,
  pesoCompetencia: null,
  pesoCompetenciaFalla: null,
  saveLoaderPesoCompetencia: false,
  pesoCompetenciaFormError:null,
  pesoCompetencias: [],
  pesoCompetenciasLenght: 0
};

export default function PesoCompetenciaReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADER_PESO_COMPETENCIA:
      return { ...state, loaderPesoCompetencia: action.payload };

    case actions.GET_PESO_COMPETENCIA:
      return { ...state, pesoCompetencia: action.payload,
        pesoCompetencias : action.payload.pesoCompetencias}

    case actions.PESO_COMPETENCIA_FALLA:
      return { ...state, pesoCompetenciaFalla: action.payload };

    case actions.SAVE_LOADER_PESO_COMPETENCIA:
      return { ...state, saveLoaderPesoCompetencia: action.payload };

    case actions.FORM_PESO_COMPETENCIA_FAIL:
      return { ...state, pesoCompetenciaFormError: action.payload };
      
    default:
      return state;
  }
}
